import React, { useCallback } from 'react'
import List from '@commonComponents/List'
import SupportingDocForm from '@EUForms/supportingDocForm'
import { useSelector } from 'react-redux'
import { selectCurrencyCodesList, selectMeasurementUnitList, selectSupportingDocumentList } from '@EUForms/selectors'
import CopyRepElement from '@commonComponents/copyRepElement'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import { Grid } from 'semantic-ui-react'
import MarkedDeleted from '../markedDeleted'

const SupportingDocDetail = (props) => {
  const { 
    dataSource, 
    isMerchandiseDisabled,
    onMarkMerchandiseDocDelete,
    ...rest 
  } = props
  const dropdownList = useSelector(selectSupportingDocumentList)
  const currencyList = useSelector(selectCurrencyCodesList)
  const uomList = useSelector(selectMeasurementUnitList)
  const {isImportShipment, isDisabled, isRFI, isRFIDisabled} = useCurrentShipmentType()
  const renderAtLast = useCallback(({
    id,
    currency, 
    unitOfMeasurement,
    onChangeHandler,
    onBlurHandler,
    onDropDownChange,
    isSupportingDocDisabled
  }) => {
    return <>
      <Grid.Column>
        <DropDown
          id={`unitOfMeasurement-${id}`}
          type='text'
          label="UOM"
          value={unitOfMeasurement}
          text={unitOfMeasurement}
          data={uomList}
          name='unitOfMeasurement'
          onChange={onDropDownChange}
          isDisabled={isSupportingDocDisabled}
        />
      </Grid.Column>
    </>
  }, [])
  const renderItem = useCallback(
    (item) => {
      const isSupportingDocDisabled = (isMerchandiseDisabled||(isRFI&&item?.markDelete=='1')||null)
      return (
      <SupportingDocForm 
        dataSource={item} 
        key={item.id} 
        currencyList={currencyList}
        docCodeList={dropdownList} 
        copyDocument={(translate) => (<CopyRepElement
          translate={translate}
          title='SUPPORTING_DOCUMENT'
          request={{...item, infoType:'EU_SUPPORTING_DOCUMENT'}}
          callback={rest?.copyData}
          isFormDisabled={isRFI||isSupportingDocDisabled||isDisabled}
          tableName={rest?.tableName}
        />)}
        renderAtLast={renderAtLast}
        {...rest} 
        isSupportingDocDisabled={isSupportingDocDisabled}
        markedDeleted={isRFI?(params) => <MarkedDeleted
          label='_'
          className='marked-deleted marked-deleted-label-hidden'
          disabled={(isRFIDisabled||isMerchandiseDisabled)}
          checked={(isSupportingDocDisabled||false)}
          onChange={
            (e, data) => onMarkMerchandiseDocDelete(data, params)
          }
        />:null}
        />
    )},
    [dropdownList, isMerchandiseDisabled, rest]
  )

  return <List className='responsiveGridCss' dataSource={dataSource} renderItem={renderItem} />
}

export default React.memo(SupportingDocDetail)
